import {
  Rive,
  decodeFont,
} from '@rive-app/canvas';

import type { FontAsset } from '@rive-app/canvas';

export const loadRive = (canvas: string, text: { key: string; value: string; path?: string; }[]) => {
  document.addEventListener('DOMContentLoaded', () => {
    // get the canvas element
    const canvasElement = document.querySelector(canvas) as HTMLCanvasElement;
    if (!canvasElement) return;
    
    const r = new Rive({
      src: canvasElement.dataset.src,
      canvas: canvasElement,
      autoplay: true,
      onLoad: () => {
        text.forEach(({ key, value, path }) => {
          if (path) {
            r.setTextRunValueAtPath(key, value, path);
          } else {
            r.setTextRunValue(key, value);
          }
        });
      },
      assetLoader: (asset, bytes) => {
        // If the asset has a CDN UUID or bytes, we don't need to load it
        if (asset.cdnUuid.length > 0 || bytes.length > 0) {
          return false;
        }
        if (asset.isFont) {
          // Fetch the font file by name and extension.
          fetch(`https://www.klaviyo.com/fonts/${asset.name}.ttf`).then(async (res) => {
            // decodeFont creates a Rive-specific Font object that `setFont()` takes
            // on the asset from assetLoader
            const font = await decodeFont(new Uint8Array(await res.arrayBuffer()));
            (asset as FontAsset).setFont(font);
        
            // Be sure to call unref to release any references.
            // This allows the engine to clean it up when it is not used by any more animations.
            font.unref();
          });
          return true;
        }
        return false;
      },
    });
  });
};
